import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { signUpSchema } from "_config/formSchemas";
import { InputControl } from "components/organism";
import { Button } from "components/atoms";
import { useLocalStorage, useOnBoarding } from "_hooks";
import logo from "_utilities/images/logo.png";
import { Base } from "components/template";

const prefix = "v-signup";


const SignUp = () => {
  const navigate = useNavigate();
  const initialized = useRef(null);
  const [searchParams] = useSearchParams();

  const { tld, fetchTld, submitSignUp } = useOnBoarding();
  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(signUpSchema(tld?.map((t) => t.domain)))
  });
  const [, setOnBoarding] = useLocalStorage("onBoarding");
  const [, setOBEmail] = useLocalStorage("OBEmail");
  const { data: response, isLoading } = useSelector((s) => s.account.signUp);

  console.log(Object.fromEntries(searchParams.entries()));
  useEffect(() => {
    if (!initialized?.current) {
      initialized.current = true;
      fetchTld();
    }
  }, [fetchTld]);
  
  useEffect(() => {
    if (response !== null) {
      setOnBoarding(response);
      setOBEmail(response?.email);
      setTimeout(() => navigate("/account/verifyEmail", { 
        state: { searchParams: Object.fromEntries(searchParams.entries())}
      }), 100);
    }
  }, [response]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Base>
      <div className={`${prefix} flex flex-wrap flex-col p-3 mx-auto w-full sm:w-2/3 md:w-3/5 lg:w-4/12 max-w-[550px]`}>
        <div className="flex flex-wrap flex-col gap-5">
          <img src={logo} alt="nbsk-logo" className="w-[55%] mx-auto" />
          <p className="text-center text-3xl font-bold mx-auto">Inicia tu prueba gratis</p>
          <p className="text-center text-xl mx-auto mb-3">Obtén 7 días gratis sin tarjeta de crédito</p>
        
          <form 
            className="flex flex-wrap flex-col gap-7"
            onSubmit={handleSubmit(submitSignUp)}
          >

            <InputControl 
              errors={errors?.email}
              label={"Correo electrónico de trabajo"}
              orientation="vertical"
              inputProps={{
                autoComplete: "off", 
                placeholder: "nombre@tuempresa.com",
                ...register("email")
              }}
            />

            <span className="text-gray-800 w-full text-center">
              ¿Ya tienes una cuenta? <Link to="/account/login" className="underline">Iniciar sesión</Link>
            </span>

            <Button
              className="bg-primary text-white rounded-lg"
              disabled={isLoading}
              pulse
              spin={isLoading}
              type="submit"
            >Continuar</Button>

            <InputControl
              errors={errors?.privacy}
              labelProps={{
                className: "flex flex-wrap items-center gap-1"
              }}
              label={<>
                Acepto <Link target="_blank" to="/terms" className="underline">términos y condiciones</Link> y <Link
                  target="_blank" to="/privacy" className="underline"
                >aviso de privacidad</Link></>}
              inputProps={{
                type: "checkbox",
                value: "checked",
                ...register("privacy")
              }}
            />
          </form>
        </div>
        
      </div>
    </Base>
  );
};

export default SignUp;
